import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Packages from './components/Packages';
import WhyUs from './components/WhyUs';
import Buses from './components/Buses';
import Hotels from './components/Hotels';
import Comparison from './components/Comparison';
import HowToBook from './components/HowToBook';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import UmrahGuide from './components/UmrahGuide';
import SeasonalPackages from './components/SeasonalPackages';
import NAPSection from './components/NAPSection';

import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import { AdminLogin, AdminDashboard } from './components/Admin';

// Simple hash-based routing for admin
const getRouteFromHash = (): string => {
  const hash = window.location.hash.slice(1);
  return hash || '/';
};

export default function App() {
  const [route, setRoute] = useState(getRouteFromHash());
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  useEffect(() => {
    const handleHashChange = () => {
      setRoute(getRouteFromHash());
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Admin routes
  if (route === '/admin') {
    if (!isAdminAuthenticated) {
      return <AdminLogin onLogin={() => setIsAdminAuthenticated(true)} />;
    }
    return (
      <AdminDashboard
        onLogout={() => {
          setIsAdminAuthenticated(false);
          window.location.hash = '';
        }}
      />
    );
  }

  // Main site
  return (
    <div className="min-h-screen bg-white" dir="rtl">
      <Header />
      <main>
        <Hero />
        <WhyUs />
        <Packages />
        <Buses />
        <Hotels />
        <Comparison />
        <SeasonalPackages />
        <UmrahGuide />
        <HowToBook />
        <Testimonials />
        <FAQ />
        <NAPSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}